export async function loadMonitoring(path, user, signal) {
  const token = await user.getIdToken();
  if (signal?.aborted) throw new DOMException('Request cancelled', 'AbortError');
  const response = await fetch(`/monitoring/api/${path}`, {
    headers: { Authorization: `Bearer ${token}` },
    cache: 'no-store',
    signal,
  });
  const body = await response.json().catch(() => null);
  if (!response.ok || !body) {
    const error = new Error(body?.error || (response.ok
      ? 'Monitoring returned an invalid response. Please refresh.'
      : `Monitoring request failed (HTTP ${response.status}). Please try again.`));
    error.status = response.status;
    throw error;
  }
  return body;
}

export const isAccessError = (error) => error.status === 401 || error.status === 403;
export const displayDate = (value) => value ? new Date(value).toLocaleString() : '—';
export const fullName = (room) => [room.firstName, room.lastName].filter(Boolean).join(' ') || room.userName || '—';
export function runningTime(start, now) {
  if (!start) return '—';
  const seconds = Math.max(0, Math.floor((now - start) / 1000));
  return `${Math.floor(seconds / 3600).toString().padStart(2, '0')}:${Math.floor(seconds / 60 % 60).toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`;
}
